/*
 * @Author       : wanchao4@xdf.cn
 * @Date         : 2021-11-01 11:06:44
 * @LastEditors  : wanchao4@xdf.cn
 * @LastEditTime : 2021-11-01 11:06:44
 * @Description  : 事件总线
 */
import Vue from 'vue';
export default new Vue();